import {
	consumeMinMax,
	checkMinMax,
	fillDateRange,
	toTimeFormat,
	parseUserInput,
	getClosestIndexes,
	stringToDate,
	dateToTime,
	timeToDate,
	getReturnDate,
	/*
	 * getClosestOption,
	 * filteredOptions,
	 */
} from './';

// Timezones
const tz = {
	utc: 'UTC',
	akl: 'Pacific/Auckland', // UTC+13
	seoul: 'Asia/Seoul', // UTC+9
	yrv: 'Asia/Yerevan', // UTC+4
	la: 'America/Los_Angeles', // UTC-8
};

describe('TimePickerUtils', () => {
	const [f1, f2] = ['hh:mm xm', 'hh:mm'];

	describe('consumeMinMax', () => {
		it('should return correct values', () => {
			let minT, maxT;

			[minT, maxT] = ['01:00', '23:55'];
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('01:00');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('23:55');

			[minT, maxT] = ['01:01 PM', '11:56 PM'];
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('13:01');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('23:56');

			[minT, maxT] = ['12:00 AM', '12:00 PM'];
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('12:00');

			minT = new Date('2023-01-01T00:00:00Z');
			maxT = new Date('2023-01-01T23:59:59Z');
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('23:59');

			// min > max
			minT = '13:00';
			maxT = new Date('2023-01-01T12:00:00Z');
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('12:00');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('13:00');

			// min > max
			minT = new Date('2023-01-01T12:00:00Z');
			maxT = '11:00';
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('11:00');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('12:00');

			// not same day
			minT = new Date('2023-02-01T08:00:00Z');
			maxT = new Date('2023-01-01T07:00:00Z');
			expect(consumeMinMax(minT, maxT, tz.utc).min).toEqual('08:00');
			expect(consumeMinMax(minT, maxT, tz.utc).max).toEqual('23:59');

			// no timezone set
			minT = new Date('2023-01-01T00:00:00');
			maxT = new Date('2023-01-01T23:59:59');
			expect(consumeMinMax(minT, maxT).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('23:59');

			[minT, maxT] = ['12:00 AM', '12:00 PM'];
			expect(consumeMinMax(minT, maxT).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('12:00');

			// undefined, null, wrong entry
			[minT, maxT] = [undefined, undefined];
			expect(consumeMinMax(minT, maxT).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('23:59');
			[minT, maxT] = ['08:00', undefined];
			expect(consumeMinMax(minT, maxT).min).toEqual('08:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('23:59');
			[minT, maxT] = [undefined, '08:00'];
			expect(consumeMinMax(minT, maxT).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('08:00');
			minT = new Date('2023-01-01T17:00:00');
			maxT = null;
			expect(consumeMinMax(minT, maxT).min).toEqual('17:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('23:59');
			minT = null;
			maxT = new Date('2023-01-01T17:00:00');
			expect(consumeMinMax(minT, maxT).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('17:00');
			[minT, maxT] = ['test', '08:00'];
			expect(consumeMinMax(minT, maxT).min).toEqual('00:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('08:00');
			[minT, maxT] = ['08:00', ''];
			expect(consumeMinMax(minT, maxT).min).toEqual('08:00');
			expect(consumeMinMax(minT, maxT).max).toEqual('23:59');
		});
	});

	describe('checkMinMax', () => {
		it('should return correct values', () => {
			let minT, maxT;

			[minT, maxT] = ['01:00', '23:55'];
			expect(checkMinMax(minT, maxT, '23:54')).toEqual(true);
			expect(checkMinMax(minT, maxT, '23:55')).toEqual(true);
			expect(checkMinMax(minT, maxT, '23:56')).toEqual(false);

			expect(checkMinMax(maxT, minT, '23:54')).toEqual(true); // Reversed min-max test

			[minT, maxT] = ['01:00 am', '1:59 am'];
			expect(checkMinMax(minT, maxT, '23:58')).toEqual(false);

			[minT, maxT] = ['01:00 am', '1:59 am'];
			expect(checkMinMax(minT, maxT, '01:00')).toEqual(true);

			[minT, maxT] = ['22:22', '22:23'];
			expect(checkMinMax(minT, maxT, '10:21 pm')).toEqual(false);
			expect(checkMinMax(minT, maxT, '10:22 pm')).toEqual(true);
			expect(checkMinMax(minT, maxT, '10:23 pm')).toEqual(true);
			expect(checkMinMax(minT, maxT, '10:24 pm')).toEqual(false);
		});
	});

	describe('fillDateRange, toTimeFormat', () => {
		it('should return correct values', () => {
			let minT, maxT, increment, range;

			[minT, maxT, increment] = ['00:00', '23:59', 1];
			range = fillDateRange(minT, maxT, increment);
			expect(range.length).toEqual(1440);
			expect(toTimeFormat.hhmmxm(range[0])).toEqual('12:00 AM');
			expect(toTimeFormat.hhmmxm(range[1439])).toEqual('11:59 PM');
			expect(toTimeFormat(range[0], f1)).toEqual('12:00 AM');
			expect(toTimeFormat(range[1439], f1)).toEqual('11:59 PM');
			// Test 24-hour values
			expect(toTimeFormat.hhmm(range[0])).toEqual('00:00');
			expect(toTimeFormat.hhmm(range[1439])).toEqual('23:59');
			expect(toTimeFormat(range[0], f2)).toEqual('00:00');
			expect(toTimeFormat(range[1439], f2)).toEqual('23:59');

			[minT, maxT, increment] = ['08:00 AM', '10:00 AM', 5];
			range = fillDateRange(minT, maxT, increment);
			expect(range.length).toEqual(25);
			expect(toTimeFormat.hhmmxm(range[0])).toEqual('08:00 AM');
			expect(toTimeFormat.hhmmxm(range[24])).toEqual('10:00 AM');

			range = fillDateRange(minT, maxT, increment); // Reversed min-max
			expect(range.length).toEqual(25);
			expect(toTimeFormat.hhmmxm(range[0])).toEqual('08:00 AM');
			expect(toTimeFormat.hhmmxm(range[24])).toEqual('10:00 AM');

			// Test string conversion to time
			expect(toTimeFormat.hhmmxm('1:23')).toEqual('01:23 AM');
			expect(toTimeFormat.hhmmxm('23:45')).toEqual('11:45 PM');
			expect(toTimeFormat.hhmmxm('8:088')).toEqual('08:08 AM');
			expect(toTimeFormat.hhmmxm('88:88')).toBeNull(); // Reject
			// Test 24-hour values
			expect(toTimeFormat.hhmm('1:23')).toEqual('01:23');
			expect(toTimeFormat.hhmm('23:45')).toEqual('23:45');
			expect(toTimeFormat.hhmm('8:088')).toEqual('08:08');
			expect(toTimeFormat.hhmm('88:88')).toBeNull(); // Reject
		});
	});

	describe('parseUserInput', () => {
		it('empty string', () => {
			expect(parseUserInput('')).toBeNull();
		});

		it('core logic 1 (no colon)', () => {
			expect(parseUserInput('2').join()).toEqual('02,00,');
			expect(parseUserInput('23').join()).toEqual('11,00,PM');
			expect(parseUserInput('24').join()).toEqual('12,00,AM');
			expect(parseUserInput('25')).toBeNull(); // Reject hour value from range 25-99
			expect(parseUserInput('99')).toBeNull();
			expect(parseUserInput('234').join()).toEqual('02,34,');
			expect(parseUserInput('2341').join()).toEqual('11,41,PM');

			expect(parseUserInput('2341a').join()).toEqual('11,41,PM'); // Hours are stronger
			expect(parseUserInput('0123p').join()).toEqual('01,23,PM');

			expect(parseUserInput('2341am').join()).toEqual('11,41,PM'); // Hours are stronger
			expect(parseUserInput('0123pm').join()).toEqual('01,23,PM');

			expect(parseUserInput('2341aa').join()).toEqual('11,41,PM'); // Hours are stronger
			expect(parseUserInput('0123pp').join()).toEqual('01,23,PM');

			expect(parseUserInput('2341aaa')).toBeNull(); // Reject
			expect(parseUserInput('2341ppp')).toBeNull(); // Reject
		});

		it('core logic 2 (with leading zero)', () => {
			expect(parseUserInput('0').join()).toEqual('12,00,');
			expect(parseUserInput('02').join()).toEqual('02,00,');
			expect(parseUserInput('023').join()).toEqual('02,30,');
			expect(parseUserInput('0234').join()).toEqual('02,34,');

			expect(parseUserInput('0234a').join()).toEqual('02,34,AM');
			expect(parseUserInput('0234p').join()).toEqual('02,34,PM');

			expect(parseUserInput('0234am').join()).toEqual('02,34,AM');
			expect(parseUserInput('0234pm').join()).toEqual('02,34,PM');
		});

		it('core logic 3 (with colon)', () => {
			expect(parseUserInput('2').join()).toEqual('02,00,');
			expect(parseUserInput('2:3').join()).toEqual('02,30,');
			expect(parseUserInput('2:34').join()).toEqual('02,34,');

			expect(parseUserInput('2:34a').join()).toEqual('02,34,AM');
			expect(parseUserInput('2:34p').join()).toEqual('02,34,PM');

			expect(parseUserInput('2:34am').join()).toEqual('02,34,AM');
			expect(parseUserInput('2:34pm').join()).toEqual('02,34,PM');

			expect(parseUserInput('2:4am').join()).toEqual('02,40,AM');
			expect(parseUserInput('2:4pm').join()).toEqual('02,40,PM');

			expect(parseUserInput('2:4aaa')).toBeNull(); // Reject
			expect(parseUserInput('2:4ppp')).toBeNull(); // Reject
		});

		it('core logic 4 (with colon and zero)', () => {
			expect(parseUserInput('02:').join()).toEqual('02,00,');
			expect(parseUserInput('02:3').join()).toEqual('02,30,');
			expect(parseUserInput('02:34').join()).toEqual('02,34,');

			expect(parseUserInput('02:34a').join()).toEqual('02,34,AM');
			expect(parseUserInput('02:34p').join()).toEqual('02,34,PM');

			expect(parseUserInput('02:34am').join()).toEqual('02,34,AM');
			expect(parseUserInput('02:34pm').join()).toEqual('02,34,PM');

			expect(parseUserInput('02:34aaa')).toBeNull(); // Reject
			expect(parseUserInput('02:34ppp')).toBeNull(); // Reject
		});

		it('edge cases, 122 vs 1220', () => {
			expect(parseUserInput('122').join()).toEqual('01,22,');
			expect(parseUserInput('122a').join()).toEqual('01,22,AM');
			expect(parseUserInput('122aaa')).toBeNull(); // Reject

			expect(parseUserInput('1220').join()).toEqual('12,20,');
			expect(parseUserInput('1220aaa')).toBeNull(); // Reject
		});

		it('edge cases, 028 vs 0280', () => {
			expect(parseUserInput('028').join()).toEqual('00,28,');
			expect(parseUserInput('028a').join()).toEqual('00,28,AM');
			expect(parseUserInput('028aaa')).toBeNull(); // Reject
		});

		it('edge cases', () => {
			expect(parseUserInput('2341T').join()).toEqual('11,41,PM');
			expect(parseUserInput('2341A').join()).toEqual('11,41,PM');
			expect(parseUserInput('99')).toBeNull(); // Reject
			expect(parseUserInput('A')).toBeNull(); // Reject
			expect(parseUserInput('$')).toBeNull(); // Reject
			expect(parseUserInput('0823AB').join()).toEqual('08,23,AM');
			expect(parseUserInput('0823QQQ')).toBeNull(); // Reject
		});

		it('input rejection', () => {
			expect(parseUserInput('0823abcd')).toBeNull(); // Reject
			expect(parseUserInput('12345').join()).toEqual('12,34,');
			expect(parseUserInput('123456')).toBeNull(); // Reject
		});
	});
});

describe('toTimeFormat, stringToDate', () => {
	it('should return correct values', () => {
		let time, date;

		time = '00:00';
		date = stringToDate(time);
		expect(toTimeFormat.hhmmxm(date)).toEqual('12:00 AM');
		expect(toTimeFormat.hhmm(date)).toEqual('00:00');

		time = '11:11 PM';
		date = stringToDate(time);
		expect(toTimeFormat.hhmmxm(date)).toEqual('11:11 PM');
		expect(toTimeFormat.hhmm(date)).toEqual('23:11');
	});
});

describe('getClosest', () => {
	it('should return correct values', () => {
		const [maxTime, minTime, increment] = ['01:00', '02:00', 30];
		const opts = fillDateRange(maxTime, minTime, increment).map((date) => ({
			value: date,
			text: toTimeFormat.hhmmxm(date),
		}));
		let time;

		time = stringToDate('00:55');
		expect(getClosestIndexes(opts, time)).toBeNull();

		time = stringToDate('01:00');
		expect(getClosestIndexes(opts, time)).toEqual([0]);

		time = stringToDate('01:01');
		expect(getClosestIndexes(opts, time)).toEqual([0, 1]);

		time = stringToDate('01:15');
		expect(getClosestIndexes(opts, time)).toEqual([0, 1]);

		time = stringToDate('01:16');
		expect(getClosestIndexes(opts, time)).toEqual([1, 0]);

		time = stringToDate('02:01');
		expect(getClosestIndexes(opts, time)).toBeNull();
	});
});

describe('timezone utils', () => {
	it('dateToTime should return correct values', () => {
		const utc0 = new Date('2023-01-01T00:00:00Z'); // 00:00 UTC, XX:00 local

		expect(dateToTime(utc0, tz.utc, 'hh:mm')).toBe('00:00');
		expect(dateToTime(utc0, tz.akl, 'hh:mm')).toBe('13:00');
		expect(dateToTime(utc0, tz.seoul, 'hh:mm')).toBe('09:00');
		expect(dateToTime(utc0, tz.yrv, 'hh:mm')).toBe('04:00');
		expect(dateToTime(utc0, tz.la, 'hh:mm')).toBe('16:00');
	});

	it('timeToDate should return correct values', () => {
		const utc0 = new Date('2023-01-01T00:00:00Z');

		let date;

		date = timeToDate('10:30'); // Today, timezone is local
		expect(dateToTime(date)).toBe('10:30 AM');

		date = timeToDate('10:30', tz.utc); // Today, timezone is UTC
		expect(dateToTime(date, tz.utc)).toBe('10:30 AM');

		date = timeToDate('10:30 PM', tz.yrv); // Today, timezone is yrv
		expect(dateToTime(date, tz.yrv, 'hh:mm')).toBe('22:30');

		date = timeToDate('10:30', tz.utc, utc0); // Date is 01/01/2023, timezone is UTC
		expect(dateToTime(date, tz.utc)).toBe('10:30 AM');
		expect(date.toISOString()).toBe('2023-01-01T10:30:00.000Z');

		date = timeToDate('01:23 AM', tz.la, utc0); // Date is 01/01/2023 00:00 UTC, timezone is la (12/31/2022 16:00)
		expect(dateToTime(date, tz.la, 'hh:mm')).toBe('01:23');
		expect(date.toISOString()).toBe('2022-12-31T09:23:00.000Z'); // 09:23 UTC = 01:23 in la, e.g. prev day is correctly used
	});

	it('getReturnDate should return correct values', () => {
		const utc0 = new Date('2023-01-01T00:00:00Z'); // 00:00 UTC, XX:00 local
		const d1 = timeToDate('10:30', tz.utc);
		const d2 = timeToDate('22:30', tz.utc);

		let date;

		// Test default values
		date = getReturnDate('12:00 AM', '23:59 PM', undefined, tz.utc);
		expect(dateToTime(date, tz.utc)).toBe('12:00 AM');

		// Test min
		date = getReturnDate(utc0, '05:30', undefined, tz.la);
		expect(dateToTime(date, tz.la)).toBe('12:00 AM');
		expect(date.toISOString()).toBe('2022-12-31T08:00:00.000Z'); // 08:00 UTC = 00:00 la

		// Test max
		date = getReturnDate('12:00 AM', d1, undefined, tz.la);
		expect(dateToTime(date, tz.la, 'hh:mm')).toBe('00:00');

		// Test min > max
		date = getReturnDate(d2, d1, undefined, tz.la);
		expect(dateToTime(date, tz.la, 'hh:mm')).toBe('00:00');

		// Test value
		date = getReturnDate('12:00 AM', '23:59 PM', utc0, tz.seoul);
		expect(dateToTime(date, tz.seoul, 'hh:mm')).toBe('00:00');
		expect(date.toISOString()).toBe('2022-12-31T15:00:00.000Z'); // 15:00 UTC = 00:00 seoul
	});
});
